import {z} from 'zod';

const clubCreateSchema = z.object({
    name: z.string()
        .min(1, {message: "Jméno klubu nesmí být prázdný"})
        .max(100, {message: "Jméno klubu nesmí být delší než 100 znaků"}),
});

type ClubCreateSchema = z.infer<typeof clubCreateSchema>;

export {clubCreateSchema, type ClubCreateSchema};
